import { UseMutationOptions, UseQueryOptions, useMutation, useQuery } from 'react-query';
import {
  getLocationEmailsWithLatestStatus,
  getLocationPersonalization,
  upsertLocationPersonalization,
} from './api';
import {
  GetLocationEmailsWithLatestStatusRequest,
  GetLocationEmailsWithLatestStatusResponse,
  GetLocationPersonalizationRequest,
  GetLocationPersonalizationResponse,
  UpsertLocationPersonalizationRequest,
} from '@weave/schema-gen-ts/dist/schemas/email/records/v1/records_service.pb';

type EmailPersonalizationError = {
  code: number;
  message: string;
  details: unknown[];
};

export const useGetLocationPersonalization = (
  { locationId }: GetLocationPersonalizationRequest,
  options?: UseQueryOptions<GetLocationPersonalizationResponse, EmailPersonalizationError>
) =>
  useQuery({
    queryKey: [locationId, 'get-location-personalization'],
    queryFn: async () => {
      return getLocationPersonalization({ locationId });
    },
    refetchOnWindowFocus: false,
    retry: 0,
    ...options,
  });

export const useUpsertLocationPersonalization = (
  options?: UseMutationOptions<void, Error, UpsertLocationPersonalizationRequest>
) => {
  return useMutation(
    ['upsert-location-personalization'],
    (req: UpsertLocationPersonalizationRequest) => upsertLocationPersonalization(req),
    options
  );
};

export const useGetLocationEmailsWithLatestStatus = (
  req: GetLocationEmailsWithLatestStatusRequest,
  options?: UseQueryOptions<
    GetLocationEmailsWithLatestStatusResponse,
    EmailPersonalizationError
  >
) =>
  useQuery({
    queryKey: [
      req.locationId,
      'get-location-emails-with-latest-status',
      req.cursor,
      req.searchQuery,
      req.createdAtStart,
      req.createdAtEnd,
      req.emailTypes,
    ],
    queryFn: async () => {
      return getLocationEmailsWithLatestStatus(req);
    },
    refetchOnWindowFocus: false,
    ...options,
  });
